module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('scroll', [_c('section', [_c('dl', {
    staticClass: "field",
    staticStyle: {
      "height": "65px"
    }
  }, [_c('span', {
    staticClass: "f-strong f-middle"
  }, [_vm._v("订单号：" + _vm._s(_vm.orderId))]), _vm._v(" "), _c('dd', {
    staticClass: "right-item f-strongest f-largest"
  }, [_vm._v(_vm._s(_vm._f("formatFee")(_vm.fee)))])])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paySuccess),
      expression: "paySuccess"
    }],
    staticClass: "pay-success-bg"
  }, [_c('div', {
    staticClass: "success-photo"
  }), _vm._v(" "), _c('label', {
    staticClass: "f-largest",
    staticStyle: {
      "margin": "10px"
    }
  }, [_vm._v("预约成功，请在医院规定时间前往\n                "), _c('br'), _vm._v("医院支付挂号费取号！\n            ")])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.payFailed),
      expression: "payFailed"
    }],
    staticClass: "pay-success-bg"
  }, [_c('div', {
    staticClass: "failed-photo"
  }), _vm._v(" "), _c('label', {
    staticClass: "f-largest"
  }, [_vm._v(_vm._s(_vm.message))])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.payOvertime),
      expression: "payOvertime"
    }],
    staticClass: "pay-success-bg"
  }, [_c('div', {
    staticClass: "failed-photo"
  }), _vm._v(" "), _c('label', {
    staticClass: "f-largest"
  }, [_vm._v("网络错误，请稍后重试")])])]), _vm._v(" "), _c('footer', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paySuccess || _vm.payOvertime),
      expression: "paySuccess || payOvertime"
    }],
    staticClass: "btn-finished",
    on: {
      "click": function($event) {
        return _vm.finished(true)
      }
    }
  }, [_vm._v("完成")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.payFailed),
      expression: "payFailed"
    }],
    staticClass: "btn-finished",
    on: {
      "click": function($event) {
        return _vm.finished(false)
      }
    }
  }, [_vm._v("完成")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cd898e9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/pay/BookingResult.vue
// module id = 806
// module chunks = 0